module.exports = __webpack_public_path__ + "img/dwg.6886777a.svg";